import { JSX } from "react";

/** Same asset as the header logo — safe to reuse for in-app system surfaces (e.g. welcome notification). */
export const CRICKET8_LOGO_SRC = "https://dyatkw7msrzcb.cloudfront.net/assets/image-1.png";

interface Props {
  className?: string;
}

export const Logo = ({ className = "" }: Props): JSX.Element => {
  return (
    <div className={`w-[300px] h-[300px] bg-cover bg-[50%_50%] ${className}`}>
      <img src={CRICKET8_LOGO_SRC} alt="Cricket8" />
    </div>
  );
};
